import React from 'react'

export default function Erorr() {
  return (
    <div>Erorr</div>
  )
}
